export default __webpack_public_path__ + "static/media/tool.a531549b.svg";